(function (merchantos) {
  // @ts-expect-error ts-migrate(2339) FIXME: Property 'payments' does not exist on type 'Mercha... Remove this comment to see the full error message
  merchantos.payments = merchantos.payments || {};

  // @ts-expect-error ts-migrate(2339) FIXME: Property 'payments' does not exist on type 'Mercha... Remove this comment to see the full error message
  const BaseProvider = merchantos.payments.getConstructor('base');

  const ACTION_TIMEOUT = 5000; // ms

  /**
   * Constructor for the Cayan/Genius payment provider; provides functionality
   * for contacting the Cayan gateway via the front-end
   *
   * @param gatewayID {Number} The ID of the credit card gateway
   * @param terminal {Object} The credit card terminal information
   *
   * @inherits BaseProvider
   * @extends BaseProvider
   * @constructor
   */
  // @ts-expect-error ts-migrate(7006) FIXME: Parameter 'gatewayID' implicitly has an 'any' type... Remove this comment to see the full error message
  function CayanPaymentProvider(gatewayID, terminal) {
    // @ts-expect-error ts-migrate(2683) FIXME: 'this' implicitly has type 'any' because it does n... Remove this comment to see the full error message
    BaseProvider.call(this);

    // @ts-expect-error ts-migrate(2683) FIXME: 'this' implicitly has type 'any' because it does n... Remove this comment to see the full error message
    this.type = terminal.type;

    // @ts-expect-error ts-migrate(2683) FIXME: 'this' implicitly has type 'any' because it does n... Remove this comment to see the full error message
    this.ccGatewayID = gatewayID;
    // @ts-expect-error ts-migrate(2683) FIXME: 'this' implicitly has type 'any' because it does n... Remove this comment to see the full error message
    this.terminal = terminal;

    const accountID = merchantos.session.getSystemCustomerID();
    // @ts-expect-error ts-migrate(2683) FIXME: 'this' implicitly has type 'any' because it does n... Remove this comment to see the full error message
    this.baseGatewayURL = `/API/Account/${accountID}/CCGateway/${this.ccGatewayID}`;
    // @ts-expect-error ts-migrate(2683) FIXME: 'this' implicitly has type 'any' because it does n... Remove this comment to see the full error message
    this.baseTerminalURL = `https://${this.terminal.configuration.address}:8443/`;
  }
  CayanPaymentProvider.prototype = Object.create(BaseProvider.prototype);
  CayanPaymentProvider.prototype.constructor = CayanPaymentProvider;

  // =================== PUBLIC FUNCTIONS ======================//

  /**
   * Function that does the work of sending a sale payment to Cayan. If the
   * API calls all succeed, will return the SalePayments array associated with
   * the created CCCharge
   *
   */
  CayanPaymentProvider.prototype.processPayment = function processPaymentFnc() {
    const deferred = $.Deferred();

    const amount = this.payment.amount;

    const url = `${this.baseGatewayURL}/GeniusCreateTransaction.json`;

    // TODO: Update regex when Cayan fixes their bug: /[^a-zA-Z0-9]/g

    const terminalKey = this.terminal.name.replace(/\D/g, '').slice(0, 15);

    this.checkStatus()
      .done(
        function () {
          // @ts-expect-error ts-migrate(2683) FIXME: 'this' implicitly has type 'any' because it does n... Remove this comment to see the full error message
          _stageTransaction(url, amount, this.saleID, terminalKey)
            .done(
              // @ts-expect-error ts-migrate(7006) FIXME: Parameter 'keys' implicitly has an 'any' type.
              function (keys) {
                const key = keys.transportKey;

                // @ts-expect-error ts-migrate(2683) FIXME: 'this' implicitly has type 'any' because it does n... Remove this comment to see the full error message
                _initiatePayment(this.baseTerminalURL, key).always(function (rawResponse) {
                  if (
                    rawResponse.Status &&
                    rawResponse.Status.toLowerCase() !== 'poscancelled' &&
                    rawResponse.Status.toLowerCase() != 'usercancelled' &&
                    rawResponse.Status.toLowerCase() != 'failed'
                  ) {
                    _updateCCCharge(keys.ccChargeID, rawResponse)
                      .done(function (response) {
                        if (rawResponse.Status.toLowerCase() === 'approved') {
                          if (rawResponse.ErrorMessage) {
                            response.errorMessage = rawResponse.ErrorMessage;
                            response.status = 'approvedError';
                            deferred.reject(response);
                          } else {
                            deferred.resolve(response);
                          }
                        } else {
                          deferred.reject({
                            status: rawResponse.Status,
                            error: rawResponse.ErrorMessage,
                            ccChargeID: keys.ccChargeID,
                          });
                        }
                      })
                      .fail(function (response) {
                        // pass along the API-reported error without the file and line number
                        const error =
                          response && response.responseJSON && response.responseJSON.message
                            ? response.responseJSON.message.replace(/ *\([^)]*\) */g, '')
                            : '';
                        deferred.reject({
                          error,
                          ccChargeID: keys.ccChargeID,
                        });
                      });
                  } else {
                    deferred.reject({
                      status: rawResponse.Status,
                      error: rawResponse.ErrorMessage,
                      ccChargeID: keys.ccChargeID,
                    });
                  }
                });
                // @ts-expect-error ts-migrate(2683) FIXME: 'this' implicitly has type 'any' because it does n... Remove this comment to see the full error message
              }.bind(this)
            )
            .fail(function (response) {
              // pass along the API-reported error without the file and line number
              const error =
                response && response.responseJSON && response.responseJSON.message
                  ? response.responseJSON.message.replace(/ *\([^)]*\) */g, '')
                  : '';
              deferred.reject({
                error,
              });
            });
        }.bind(this)
      )
      .fail(function () {
        deferred.reject({
          error: 'Terminal is offline, the transaction could not be started.',
        });
      });

    return deferred.promise();
  };

  /**
   * Does the work of cancelling the transaction from the POS (not terminal)
   */
  CayanPaymentProvider.prototype.cancelTransaction = function cancelFnc() {
    const url = `${this.baseTerminalURL}v1/pos?Action=Cancel&Format=JSON`;

    return _callSoap(url, 'GET', ACTION_TIMEOUT);
  };

  /**
   * Calls out to the terminal to check the status
   */
  CayanPaymentProvider.prototype.checkStatus = function statusFnc() {
    const url = `${this.baseTerminalURL}v2/pos?Action=Status&Format=JSON`;

    return _callSoap(url, 'GET', ACTION_TIMEOUT);
  };

  // ========================== PRIVATE FUNCTIONS ==========================//

  /**
   * Creates a genius transaction and returns keys to initialize transaction
   * on a Genius terminal
   *
   * @param url {String} The gateway URL to call to stage the transaction
   * @param amount {Number} The payment amount for this transaction
   * @param saleID {Number} The unique ID of the sale
   * @param key {String} The terminal key to send to Merchantware
   * @returns promise
   * @private
   */
  // @ts-expect-error ts-migrate(7006) FIXME: Parameter 'url' implicitly has an 'any' type.
  function _stageTransaction(url, amount, saleID, key) {
    const deferred = $.Deferred();
    const data = {
      amount,
      // @ts-expect-error ts-migrate(2531) FIXME: Object is possibly 'null'.
      employeeID: merchantos.session.getEmployee().employeeID,
      saleID,
      terminalKey: key,
    };

    window.lsCloud
      .startServerJob(
        {
          type: 'POST',
          url,
          obj: data,
        },
        false
      )
      .done(function (response) {
        deferred.resolve(response.GeniusTransactionKeys);
      })
      .fail(function (response) {
        deferred.reject(response);
      });

    return deferred.promise();
  }

  /**
   * Sends data to the gateway to initiate a payment. It waits for a response
   * from the terminal, either a cancel response, a success, or a decline
   *
   * @param baseURL {String} The IP address of the terminal
   * @param transportKey {String} Transport key returned by the gateway
   * @returns Promise
   * @private
   */
  // @ts-expect-error ts-migrate(7006) FIXME: Parameter 'baseURL' implicitly has an 'any' type.
  function _initiatePayment(baseURL, transportKey) {
    const deferred = $.Deferred();

    const url = `${baseURL}v2/pos?TransportKey=${transportKey}&Format=JSON`;

    // @ts-expect-error ts-migrate(2554) FIXME: Expected 3 arguments, but got 2.
    _callSoap(url, 'GET')
      .done(function (rawResponse) {
        deferred.resolve(rawResponse);
      })
      .fail(function (e) {
        deferred.reject(e);
      });

    return deferred.promise();
  }

  /**
   * Performs a PUT against CCCharge with the raw response data from the gateway
   *
   * @param ccChargeID {Number} ID of the CCCharge created for this transaction
   * @param rawResponse {Object} Response data from gateway
   * @returns Promise
   * @private
   */
  // @ts-expect-error ts-migrate(7006) FIXME: Parameter 'ccChargeID' implicitly has an 'any' typ... Remove this comment to see the full error message
  function _updateCCCharge(ccChargeID, rawResponse) {
    const deferred = $.Deferred();

    const custID = merchantos.session.getSystemCustomerID();

    const url = `/API/Account/${custID}/CCCharge/${ccChargeID}.json`;

    const base64Response = btoa(JSON.stringify(rawResponse));

    window.lsCloud
      .startServerJob({
        url,
        type: 'PUT',
        obj: {
          terminalResponse: base64Response,
        },
      })
      .done(function (response) {
        deferred.resolve(response.CCCharge.SalePayments);
      })
      .fail(function (response) {
        deferred.reject(response);
      });

    return deferred.promise();
  }

  /**
   * Contacts the physical terminal to initialize payments, cancel payments,
   * check status, etc.
   *
   * @param url {String} The URL to contact
   * @param type {String} The HTTP request type
   * @param timeout {Number} The value in milliseconds before the request
   * @private
   */
  // @ts-expect-error ts-migrate(7006) FIXME: Parameter 'url' implicitly has an 'any' type.
  function _callSoap(url, type, timeout) {
    const ajaxOptions = {
      type: type || 'GET',
      url,
    };

    if (timeout) {
      // @ts-expect-error ts-migrate(2339) FIXME: Property 'timeout' does not exist on type '{ type:... Remove this comment to see the full error message
      ajaxOptions.timeout = timeout;
    }

    return $.ajax(ajaxOptions);
  }

  // @ts-expect-error ts-migrate(2339) FIXME: Property 'payments' does not exist on type 'Mercha... Remove this comment to see the full error message
  merchantos.payments.registerProvider('Genius', CayanPaymentProvider);
})(window.merchantos);
